import { render, staticRenderFns } from "./NuevaPractica.vue?vue&type=template&id=ba776790&scoped=true&"
import script from "./NuevaPractica.vue?vue&type=script&lang=js&"
export * from "./NuevaPractica.vue?vue&type=script&lang=js&"
import style0 from "./NuevaPractica.vue?vue&type=style&index=0&id=ba776790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba776790",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCard,VCol,VDivider,VRow,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
